<template>
  <a-card :bordered="false">
    <a-row>
      <a-col :span="8">
        <a-button type="primary" @click="openModel">添加供应商</a-button>
      </a-col>
      <a-col :span="8" :offset="8" style="text-align: right;">
        <a-button @click="goRules">同步规则</a-button>
      </a-col>
    </a-row>
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      style="margin-top:16px;"
      :columns="columns"
      :request-promise="getListPromise"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.state===0" @click="onUpdateEvent(rowItem.record.id)">启用</a>
        <a v-else style="color:red;" @click="onUpdateEvent(rowItem.record.id)">禁用</a>
      </span>
    </custom-page-table>
    <a-modal :title="id?'编辑供应商':'添加供应商'" :width="666" :footer="null"
             :afterClose="afterClose"
             :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" :maxLength="6"
                   placeholder="仅用于区分标识数据来源，6个字内"></a-input>
        </a-form-model-item>
        <a-form-model-item label="客户端代码(clientCode)" prop="clientCode">
          <a-input v-model.trim="ruleForm.clientCode" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="密码(PassWord)" prop="password">
          <a-input v-model.trim="ruleForm.password" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="(token)" prop="token">
          <a-input v-model.trim="ruleForm.token" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 8 }">
          <a-button type="primary" @click="handleSubmit" style="width: 150px;margin-right: 20px;">提交</a-button>
          <a-button @click="handleCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'AssociatedAccount',
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '客户端代码(clientCode)',
          dataIndex: 'clientCode'
        },
        {
          title: '状态',
          dataIndex: 'stateStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '240px',
          fixed: 'right'
        }
      ],
      visible: false,
      ruleForm: {
        supplierName: '',
        clientCode: '',
        token: '',
        password: ''
      },
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
      rules: {
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: ['blur', 'change'] }],
        clientCode: [{ required: true, message: '请输入客户端代码(clientCode)', trigger: ['blur', 'change'] }],
        token: [{ required: true, message: '请输入token', trigger: ['blur', 'change'] }],
        password: [{ required: true, message: '请输入密码(PassWord)', trigger: ['blur', 'change'] }]
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      id: ''
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'PMSProductList', title: '同步商品' },
      { name: 'PMSDirectOrdersList', title: '订单直连' },
      { name: 'PMSAssociatedAccount', title: '关联账号' }
    ])
  },
  methods: {
    afterClose() {
      this.id = ''
    },
    handleCancel() {
      this.visible = false
    },
    getListPromise(params) {
      this.getLogUtils().logWithTag('====params======', params)
      let param = {
        ...params,
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      return this.getHttpServices().getServerApiService().post('lvyun/link/queryLvYunAccountList', param)
    },
    submitEvent() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        supplierName: this.ruleForm.supplierName,
        clientCode: this.ruleForm.clientCode,
        token: this.ruleForm.token,
        password: this.ruleForm.password
      }
      if (this.id) {
        params.id = this.id
      }
      let msg = this.id ? '编辑成功' : '成功添加'
      this.getHttpServices().getServerApiService().post('lvyun/link/editLvYunAccount', params)
        .then(res => {
          this.$message.success(msg)
          this.syncLvYunHotel()
          this.visible = false
          this.$refs.table.refresh(true)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    syncLvYunHotel() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('lvyun/link/syncLvYunHotel', params)
        .then(res => {
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitEvent()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleAccountSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // this.submitEvent()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    openModel() {
      this.ruleForm = {}
      this.visible = true
    },
    goRules() {
      this.$router.push({
        name: 'PMSSynchronizationRules',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    editEvent(record) {
      this.id = record.id
      this.getSupplierDetails(record.id)
    },
    getSupplierDetails(id) {
      let url = 'lvyun/link/findLvYunAccount'
      this.getHttpServices().getServerApiService().get(url, { id: id })
        .then(res => {
          this.ruleForm.supplierName = res.supplierName
          this.ruleForm.clientCode = res.clientCode
          this.ruleForm.token = res.token
          this.ruleForm.password = res.password
          this.visible = true

        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    onUpdateEvent(id) {
      let params = {
        id: id
      }
      this.getHttpServices().getServerApiService().post('lvyun/link/updateLvYunState', params)
        .then(res => {
          this.$refs.table.refresh(true)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
</script>

<style scoped>

</style>